import React, {Component} from 'react';
import {CrmLayoutBar} from "../../../../LayoutCrm";
import LeadsList from "./LeadsList";
import AddLeadModal from "./AddLeadModal";
import {API_URL} from "../../../../settings/local_settings";
import {APIClient} from "../../../../utils/APIClient";
import {LocalStorage} from "../../../../utils/LocalStorage";
import LeadFilters from "./LeadFilters";
import {withRouterParams} from "../../../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class LeadsPage extends Component {
    constructor(props) {
        super(props);

        this.handleLeadAdd = this.handleLeadAdd.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleDateFilterChange = this.handleDateFilterChange.bind(this);
        this.handleClearTextFilterClick = this.handleClearTextFilterClick.bind(this);
        this.handleDownloadLeads = this.handleDownloadLeads.bind(this);

        this.state = {
            filterValues: {
                text: '',
                status: '',
                fromDate: null,
                toDate: null
            },
            isDownloading: false
        }
    }

    // URLS

    crmApiURL() {
        return `${API_URL}${this.crmApiPath()}`;
    }

    crmApiPath() {
        return `crm/${this.clientID()}`;
    }

    clientID() {
        let clientId;
        if (LocalStorage.hasUserClientId()) {
            clientId = LocalStorage.fetchUserClientId();
        } else {
            clientId = this.props.match.params.clientId;
        }
        return clientId;
    }

    crmFrontPath() {
        let clientId;
        if (this.props.match.params.hasOwnProperty('clientId')) {
            clientId = this.props.match.params.clientId;
            return `crm/${clientId}`;
        } else {
            return `crm`;
        }
    }

    // handlers

    handleLeadAdd(leadId) {
        this.props.history.push(`/${this.crmFrontPath()}/lead/${leadId}`);
    }

    handleFilterChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState((prevState) => {
            return {filterValues: {...prevState.filterValues, [name]: target.value}}
        });
    }

    handleDateFilterChange(dates) {
        this.setState((prevState) => {
            return {
                filterValues: {
                    ...prevState.filterValues,
                    fromDate: dates.startDate,
                    toDate: dates.endDate,
                }
            }
        });
    }

    handleClearTextFilterClick() {
        this.setState((prevState) => {
            return {filterValues: {...prevState.filterValues, text: ''}}
        });

    }

    handleDownloadLeads() {
        this.setIsDownloadingState(true);
        let downloadResponse = this.downloadLeads();
        downloadResponse.then(response => {
            this.setIsDownloadingState(false)
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="crm-content">
                <CrmLayoutBar crmFrontPath={this.crmFrontPath()}/>
                <section className="crm-section-content">
                    <header className="crm-section-header">
                        <h1 className="section-title">{t('leads_page.title')}</h1>
                        <AddLeadModal crmApiURL={this.crmApiURL()} onLeadAdd={this.handleLeadAdd}/>
                    </header>
                    {this.renderLeadFilters()}
                    {this.renderLeadList()}
                </section>
            </div>
        )
    }

    renderLeadList() {
        return <LeadsList filterValues={this.state.filterValues}
                          crmFrontPath={this.crmFrontPath()} crmApiURL={this.crmApiURL()}
        />;
    }

    renderLeadFilters() {
        return <LeadFilters filterValues={this.state.filterValues}
                            onDateFilterChange={this.handleDateFilterChange}
                            onFilterChange={this.handleFilterChange}
                            onHandleClearTextFilterClick={this.handleClearTextFilterClick}
                            onDownloadLeads={this.handleDownloadLeads}
                            isDownloading={this.state.isDownloading}
        />
    }

    downloadLeads() {
        return new APIClient(`${API_URL}crm/${this.clientID()}/export`).download('GET', this.defaultLeadsFilename());
    }

    defaultLeadsFilename() {
        return `leads-for-client-${this.clientID()}.csv`;
    }

    setIsDownloadingState(isDownloading) {
        this.setState({isDownloading: isDownloading});
    }
}

export default withRouterParams(withTranslation()(LeadsPage));